import {makeStyles} from '@material-ui/core/styles';
import React, {useState, useEffect} from 'react';

import Api from '../../../config/api';
import swal from 'sweetalert';
import Grid from '@material-ui/core/Grid';
import globalContext from '../../../config/context';
import Numeral from 'numeral';

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const useHook = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [
    {refreshLegend, pencarian, checkedBphtb, checkedPendataan},
    {setRefreshLegend, setPencarian, setAlert, setLoading},
  ] = useAppContext();
  const {kelurahanRefGeoJson} = props;

  //Legend Tematik------------------------------------------------------------------------------------------------------
  const [legend, setLegend] = React.useState([]);
  const [onRefresh, setOnRefresh] = React.useState(true);

  useEffect(() => {
    legendTematik();
  }, [pencarian]);
  // console.log(pencarian.state);

  useEffect(() => {
    legendTematik();
  }, [refreshLegend]);

  const legendTematik = () => {
    Api.get('gis/legend/' + pencarian.state, {
      kec: pencarian.kecamatan,
      kel: pencarian.kelurahan,
      tahun: pencarian.tahun,
    })
      .then(function (response) {
        if (response) {
          // console.log(response.data);
          // //---setLegend--------
          let tmp = [];
          response.data.map((value, key) => {
            tmp.push({
              label: value.text,
              warna: value.warna,
            });
          });
          setLegend(tmp);
          //--------------------
        }
      })
      .finally(function () {});
  };

  //Legend BPHTB--------------------------------------------------------------------------------------------------------
  const [legendBphtb, setLegendBphtb] = React.useState([]);

  useEffect(() => {
    legendRangeBphtb();
  }, [checkedBphtb]);

  const legendRangeBphtb = () => {
    Api.get('gis/legend/bphtb')
      .then(function (response) {
        if (response) {
          // console.log(response.data);
          // //---setLegend--------
          let tmp = [];
          response.data.map((value, key) => {
            tmp.push({
              warna: value.warna,
              // label: value.min + ' - ' + value.max,
              label: 'Rp.' + Numeral(value.min).format('0,0') + ' - ' + 'Rp.' + Numeral(value.max).format('0,0'),
            });
          });
          setLegendBphtb(tmp);
          //--------------------
        }
      })
      .finally(function () {});
  };

  //Legend Pendataan--------------------------------------------------------------------------------------------------------
  const [legendPendataan, setLegendPendataan] = React.useState([]);

  useEffect(() => {
    LegendPendataan();
  }, [checkedPendataan]);

  const LegendPendataan = () => {
    Api.get('gis/legend/pendataan')
      .then(function (response) {
        if (response) {
          // console.log(response.data);
          // //---setLegend--------
          let tmp = [];
          response.data.map((value, key) => {
            tmp.push({
              label: value.text,
              warna: value.warna,
            });
          });
          setLegendPendataan(tmp);
          //--------------------
        }
      })
      .finally(function () {});
  };

  return [{legend, legendBphtb, legendPendataan}];
};

export default useHook;
